import { composeMapper } from '@wix/editor-elements-preview-utils';
import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import {
  LoginSocialBarDefinition,
  LoginSocialBarPlatformProps,
} from '../LoginSocialBar.types';
import { props as viewerPropsMapper } from './LoginSocialBar.mapper';

const props = composeMapper<
  LoginSocialBarPlatformProps,
  LoginSocialBarDefinition,
  LoginSocialBarPlatformProps
>()(
  viewerPropsMapper,
  { add: ['compPreviewState'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { compPreviewState } = deps;
    const isMenuOpen =
      compPreviewState && compPreviewState.includes('loggedInMenuOpened');

    return {
      ...viewerProps,
      isMenuOpen,
      previewWrapperProps: { compPreviewState },
    };
  },
);

export default createComponentPreviewMapperModel({ props });
